export default __webpack_public_path__ + "static/media/a008-D.c25f15c7.svg";